var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivateUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    fill: "white",
    stroke: "#F3F3F3",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8672 27.8335C27.8672 22.4026 32.2698 18 37.7007 18C43.1315 18 47.5342 22.4026 47.5342 27.8335C47.5342 33.2644 43.1315 37.667 37.7007 37.667C32.2698 37.667 27.8672 33.2644 27.8672 27.8335ZM37.7007 21.9334C34.4421 21.9334 31.8006 24.575 31.8006 27.8335C31.8006 31.092 34.4421 33.7336 37.7007 33.7336C40.9593 33.7336 43.6008 31.092 43.6008 27.8335C43.6008 24.575 40.9593 21.9334 37.7007 21.9334Z",
    fill: "black",
    fillOpacity: 0.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8656 39.6337H33.7669C26.1636 39.6337 20 45.7973 20 53.4005V55.3672C20 56.4534 20.8805 57.3339 21.9667 57.3339H38.2012C37.3726 56.146 36.7266 54.8213 36.3037 53.4005H23.9334C23.9334 47.9697 28.336 43.5671 33.7669 43.5671H37.0583C37.7587 42.0928 38.7133 40.7627 39.8656 39.6337Z",
    fill: "black",
    fillOpacity: 0.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5009 51.4339C50.5871 51.4339 51.4676 50.5534 51.4676 49.4672C51.4676 48.381 50.5871 47.5005 49.5009 47.5005C48.4147 47.5005 47.5342 48.381 47.5342 49.4672C47.5342 50.5534 48.4147 51.4339 49.5009 51.4339Z",
    fill: "black",
    fillOpacity: 0.19
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4006 39.6336V41.936C57.6922 42.7459 59.334 44.9315 59.334 47.5004V51.4338C59.334 54.6924 56.6925 57.3339 53.4339 57.3339H45.5671C42.3085 57.3339 39.667 54.6924 39.667 51.4338V47.5004C39.667 44.9315 41.3088 42.7459 43.6004 41.936V39.6336C43.6004 36.375 46.2419 33.7335 49.5005 33.7335C52.7591 33.7335 55.4006 36.375 55.4006 39.6336ZM51.4672 39.6336V41.6003H47.5338V39.6336C47.5338 38.5474 48.4143 37.6669 49.5005 37.6669C50.5867 37.6669 51.4672 38.5474 51.4672 39.6336ZM43.6004 47.5004C43.6004 46.4142 44.4809 45.5337 45.5671 45.5337H53.4339C54.5201 45.5337 55.4006 46.4142 55.4006 47.5004V51.4338C55.4006 52.52 54.5201 53.4005 53.4339 53.4005H45.5671C44.4809 53.4005 43.6004 52.52 43.6004 51.4338V47.5004Z",
    fill: "black",
    fillOpacity: 0.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateUser);
export default __webpack_public_path__ + "static/media/private-user.6d7245b771948d817a1442461789eff6.svg";
export { ForwardRef as ReactComponent };